// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Cd4I8","content":"styles_content__3jfJX","selectAll":"styles_selectAll__3_orZ"};